import differenceInDays from 'date-fns/differenceInDays';

type TimeGuardRecord = {
  timeoutInDays: number;
  date: string; // ISO string
};

class TimeGuard {
  constructor(private storageKey: string) {}

  static create(storageKey: string) {
    return new TimeGuard(storageKey);
  }

  check(countFirstRun = true): boolean {
    let lastRequest: string | null = null;
    try {
      lastRequest = window.localStorage.getItem(this.storageKey);
    } catch (_e) {
      // ignore access errors (e.g., privacy mode)
    }

    if (lastRequest) {
      try {
        const data = JSON.parse(lastRequest) as Partial<TimeGuardRecord>;
        const timeout =
          typeof data.timeoutInDays === 'number'
            ? data.timeoutInDays
            : Number(data.timeoutInDays);
        const dateStr = data.date;
        if (timeout && typeof dateStr === 'string') {
          const storedDate = new Date(dateStr);
          if (!Number.isNaN(storedDate.getTime())) {
            return differenceInDays(new Date(), storedDate) >= timeout;
          }
        }
      } catch (_e) {
        // ignore malformed JSON
      }
    }

    if (!countFirstRun) {
      this.setTimeoutForDays(1);
      return false;
    }
    return true;
  }

  setTimeoutForDays(timeoutInDays: number): void {
    const data: TimeGuardRecord = {
      timeoutInDays,
      date: new Date().toISOString(),
    };
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(data));
    } catch (_e) {
      // ignore storage write errors
    }
  }
}

export default TimeGuard;
